module.exports = __webpack_public_path__ + "media/home_mobile_video.b5f2022d.mp4";